/* Canonical client-side mirrors of the server gate in
   pear-payments-backend/src/zana/engine/classify.js.

   WHY A SEPARATE, IMPORT-FREE MODULE:
   `forbidsAlertClear` existed in BOTH zanaLocalAsk.ts and zanaAskShared.ts and
   the two copies had already diverged — the shared one grew a third clause the
   local one never got. Two regexes that must agree, edited independently, is a
   silent-drift machine: the client can refuse to clear alerts on one surface
   and offer to clear them on the other, from the same sentence.

   This file imports NOTHING so both consumers can depend on it without forming
   a cycle (zanaAskShared → briefingsApi → zanaLocalAsk already links those
   three). Keep it that way: patterns only, no state, no I/O. */

/** "don't clear alerts" is not a request to clear them. */
export function forbidsAlertClear(question: string): boolean {
  const q = String(question || '');
  return /\b(don'?t|do not|never|skip|without)\b.{0,28}\b(clear|triage|mark|dismiss)\b.{0,32}\b(alerts?|high[- ]?risk|queue)\b/i.test(q)
    || /\b(don'?t|do not|never)\b.{0,20}\b(open|show|touch|handle)\b.{0,24}\b(high[- ]?risk|alerts?)\b/i.test(q)
    || /\b(don'?t|do not|never)\s+(clear|touch)\b.{0,24}\b(alerts?|high[- ]?risk)\b/i.test(q);
}

/** Positive request to WORK the High Risk queue, not a mention of the card. */
export function ownerAskedForAlertWork(question: string): boolean {
  const q = String(question || '');
  if (forbidsAlertClear(q)) return false;
  return /\b(clear|triage|mark|open|show|walk)\b.{0,32}\b(high[- ]?risk|alerts?)\b/i.test(q)
    || /\b(high[- ]?risk|alerts?)\b.{0,32}\b(clear|triage|open|walk|show)\b/i.test(q);
}
